import { innerHTML } from 'diffhtml';
import { fetchJson } from './../core/ajax-json.js';
import currencyFormatter from './../libs/currency-formatter.js';
import { getLocale } from './../libs/locale.js';

function setupJackpot(sectionElement) {
	const jackpotElements = sectionElement.getElementsByClassName('game-item__jackpot');
	fetchJson('/player/currency').then((response) => {
		const currency = response.result;
		for (let i = 0; i < jackpotElements.length; i += 1) {
			const jackpotAmount = jackpotElements[i].dataset.amount;
			innerHTML(jackpotElements[i], currencyFormatter.format(jackpotAmount, currency, getLocale()));
		}
	});
}

export { setupJackpot };



// WEBPACK FOOTER //
// ./mobile-core/src/casino/jackpot-render.js